// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   COMMUNITY LIST - MODERN GLASSMORPHIC REDESIGN
   ========================================================================== */

.CommunityListContainer {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 28px 20px 60px 20px;
  color: #f8fafc;
  font-family: "Instrument Sans", "Inter", -apple-system, sans-serif;
  box-sizing: border-box;
}

/* --------------------------------------------------------------------------
   1. PAGE HEADER SECTION
   -------------------------------------------------------------------------- */
.community-header-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 28px;
  padding: 24px 28px;
  background: linear-gradient(135deg, rgba(16, 35, 33, 0.6) 0%, rgba(9, 20, 20, 0.85) 100%);
  border: 1px solid rgba(72, 209, 204, 0.16);
  border-radius: 20px;
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.community-header-left {
  flex: 1 1;
  min-width: 280px;
}

.community-header-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(72, 209, 204, 0.12);
  border: 1px solid rgba(72, 209, 204, 0.3);
  color: #48d1cc;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11.5px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-bottom: 10px;
}

.community-page-title {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.5px;
  margin: 0 0 6px 0;
  color: #ffffff;
  background: linear-gradient(105deg, #ffffff 40%, #7ee6e1 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.community-page-subtitle {
  font-size: 14px;
  line-height: 1.55;
  color: #94a3b8;
  max-width: 720px;
  margin: 0;
}

.community-header-stats {
  display: flex;
  gap: 10px;
  align-items: center;
}

.stat-pill {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 18px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  min-width: 76px;
}

.stat-pill-joined {
  background: rgba(72, 209, 204, 0.08);
  border-color: rgba(72, 209, 204, 0.25);
}

.stat-num {
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1;
  margin-bottom: 2px;
}

.stat-pill-joined .stat-num {
  color: #48d1cc;
}

.stat-label {
  font-size: 11px;
  font-weight: 500;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

/* --------------------------------------------------------------------------
   2. UNLOCKED FOR YOU - SPOTLIGHT HUB
   -------------------------------------------------------------------------- */
.community-spotlight-hub {
  margin-bottom: 28px;
  background: rgba(13, 27, 26, 0.45);
  border: 1px solid rgba(72, 209, 204, 0.18);
  border-radius: 18px;
  padding: 20px 22px;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.spotlight-hub-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}

.spotlight-hub-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15.5px;
  font-weight: 700;
  color: #f1f5f9;
  letter-spacing: -0.2px;
}

.spotlight-hub-count {
  font-size: 11px;
  font-weight: 600;
  background: rgba(72, 209, 204, 0.15);
  border: 1px solid rgba(72, 209, 204, 0.35);
  color: #48d1cc;
  padding: 2px 8px;
  border-radius: 10px;
}

.spotlight-hub-sub {
  font-size: 12.5px;
  color: #64748b;
}

.spotlight-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 14px;
}

.spotlight-card {
  background: linear-gradient(145deg, rgba(20, 39, 37, 0.6) 0%, rgba(11, 23, 23, 0.8) 100%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  padding: 16px 18px;
  cursor: pointer;
  transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.spotlight-card:hover {
  transform: translateY(-2px);
  border-color: rgba(72, 209, 204, 0.35);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4), 0 0 16px rgba(72, 209, 204, 0.12);
}

.spotlight-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(72, 209, 204, 0.5), transparent);
  opacity: 0;
  transition: opacity 0.2s ease;
}

.spotlight-card:hover::before {
  opacity: 1;
}

.spotlight-card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.spotlight-tag {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: 12px;
  border: 1px solid;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.spotlight-members {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11.5px;
  color: #94a3b8;
}

.spotlight-name {
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 6px 0;
  line-height: 1.3;
}

.spotlight-description {
  font-size: 12.5px;
  line-height: 1.45;
  color: #94a3b8;
  margin: 0 0 14px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  flex: 1 1;
}

.spotlight-card-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.spotlight-qual-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 500;
  color: #cbd5e1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.spotlight-join-btn {
  background: linear-gradient(135deg, #48d1cc 0%, #20b2aa 100%);
  color: #061c1b;
  border: none;
  font-size: 12px;
  font-weight: 700;
  padding: 7px 16px;
  border-radius: 20px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  box-shadow: 0 2px 10px rgba(72, 209, 204, 0.25);
}

.spotlight-join-btn:hover:not(:disabled) {
  transform: scale(1.03);
  box-shadow: 0 4px 14px rgba(72, 209, 204, 0.4);
}

.spotlight-join-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* --------------------------------------------------------------------------
   3. CONTROL DECK (SEARCH + TABS)
   -------------------------------------------------------------------------- */
.community-control-deck {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.community-search-bar-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.community-search-wrapper {
  position: relative;
  flex: 1 1;
  min-width: 260px;
}

.community-search-input {
  width: 100%;
  padding: 12px 38px 12px 16px;
  background: rgba(15, 30, 28, 0.65);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: #ffffff;
  font-size: 14px;
  font-family: inherit;
  outline: none;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  box-sizing: border-box;
  transition: all 0.2s ease;
}

.community-search-input:focus {
  border-color: #48d1cc;
  background: rgba(15, 30, 28, 0.9);
  box-shadow: 0 0 0 3px rgba(72, 209, 204, 0.15), 0 4px 16px rgba(0, 0, 0, 0.3);
}

.community-search-input::placeholder {
  color: #64748b;
  font-size: 13.5px;
}

.search-clear-btn {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.08);
  border: none;
  color: #94a3b8;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s ease;
}

.search-clear-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

.filter-summary-info {
  font-size: 13px;
  color: #64748b;
  white-space: nowrap;
}

.filter-summary-info strong {
  color: #e2e8f0;
  font-weight: 600;
}

/* Modern Segmented Filter Bar with Visible Scrollbar & Overflow Hints */
.community-filter-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 8px;
  background: rgba(10, 22, 21, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.filter-tabs-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1;
  min-width: 260px;
  overflow: hidden;
}

/* Gradient edge masks to indicate hidden scrollable content */
.filter-tabs-wrapper::before,
.filter-tabs-wrapper::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 6px;
  width: 32px;
  pointer-events: none;
  z-index: 2;
  opacity: 0;
  transition: opacity 0.25s ease;
}

.filter-tabs-wrapper::before {
  left: 0;
  background: linear-gradient(90deg, rgba(10, 22, 21, 0.95) 0%, transparent 100%);
}

.filter-tabs-wrapper::after {
  right: 0;
  background: linear-gradient(270deg, rgba(10, 22, 21, 0.95) 0%, transparent 100%);
}

.filter-tabs-wrapper.has-scroll-left::before {
  opacity: 1;
}

.filter-tabs-wrapper.has-scroll-right::after {
  opacity: 1;
}

/* Slim custom glowing scrollbar */
.filter-tabs-track {
  display: flex;
  align-items: center;
  gap: 6px;
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
  padding-bottom: 6px;
  scrollbar-width: thin;
  scrollbar-color: rgba(72, 209, 204, 0.45) rgba(255, 255, 255, 0.04);
  scroll-behavior: smooth;
}

.filter-tabs-track::-webkit-scrollbar {
  height: 4px;
}

.filter-tabs-track::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.04);
  border-radius: 4px;
  margin: 0 4px;
}

.filter-tabs-track::-webkit-scrollbar-thumb {
  background: linear-gradient(90deg, rgba(72, 209, 204, 0.5), rgba(32, 178, 170, 0.65));
  border-radius: 4px;
}

.filter-tabs-track::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(90deg, rgba(72, 209, 204, 0.8), rgba(32, 178, 170, 0.95));
}

/* Scroll Arrow Navigation Buttons */
.tabs-scroll-btn {
  position: absolute;
  top: calc(50% - 3px);
  transform: translateY(-50%);
  z-index: 3;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: rgba(14, 30, 28, 0.9);
  border: 1px solid rgba(72, 209, 204, 0.35);
  color: #48d1cc;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
  transition: all 0.18s ease;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.tabs-scroll-btn:hover {
  background: rgba(72, 209, 204, 0.25);
  border-color: #48d1cc;
  color: #ffffff;
  transform: translateY(-50%) scale(1.08);
}

.scroll-btn-left {
  left: 2px;
}

.scroll-btn-right {
  right: 2px;
}

.filter-tab-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: 1px solid transparent;
  color: #94a3b8;
  font-size: 13.5px;
  font-weight: 500;
  font-family: inherit;
  padding: 7px 16px;
  border-radius: 10px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-user-select: none;
          user-select: none;
}

.filter-tab-pill:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.05);
}

.filter-tab-pill.active {
  background: linear-gradient(135deg, rgba(72, 209, 204, 0.18) 0%, rgba(32, 178, 170, 0.24) 100%);
  border: 1px solid rgba(72, 209, 204, 0.4);
  color: #48d1cc;
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25), inset 0 1px 0 rgba(72, 209, 204, 0.2);
}

.filter-tab-text {
  letter-spacing: -0.1px;
}

.filter-tab-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.07);
  color: #94a3b8;
  font-size: 11px;
  font-weight: 600;
  padding: 1px 7px;
  border-radius: 9999px;
  min-width: 14px;
  transition: all 0.2s ease;
}

.filter-tab-pill:hover .filter-tab-count {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.12);
}

.filter-tab-pill.active .filter-tab-count {
  background: rgba(72, 209, 204, 0.25);
  color: #ffffff;
}

/* --------------------------------------------------------------------------
   4. COMMUNITY CARDS GRID
   -------------------------------------------------------------------------- */
.community-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 20px;
}

.community-card {
  background: linear-gradient(160deg, rgba(17, 33, 31, 0.7) 0%, rgba(8, 18, 18, 0.9) 100%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}

.community-card:hover {
  transform: translateY(-4px);
  border-color: rgba(72, 209, 204, 0.35);
  box-shadow: 0 14px 32px rgba(0, 0, 0, 0.5), 0 0 20px rgba(72, 209, 204, 0.1);
}

/* Card Banner */
.community-card-banner {
  height: 90px;
  background-size: cover;
  background-position: center;
  background-color: #0c1a19;
  position: relative;
  padding: 12px 14px;
  box-sizing: border-box;
}

.community-card-banner-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(6, 15, 14, 0.3) 0%, rgba(6, 15, 14, 0.85) 100%);
}

.card-top-row {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.category-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 12px;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.city-tag {
  background: rgba(56, 189, 248, 0.15);
  border: 1px solid rgba(56, 189, 248, 0.35);
  color: #38bdf8;
}

.political-tag {
  background: rgba(129, 140, 248, 0.15);
  border: 1px solid rgba(129, 140, 248, 0.35);
  color: #a5b4fc;
}

.profession-tag {
  background: rgba(245, 158, 11, 0.15);
  border: 1px solid rgba(245, 158, 11, 0.35);
  color: #fbbf24;
}

.merit-tag {
  background: rgba(72, 209, 204, 0.15);
  border: 1px solid rgba(72, 209, 204, 0.35);
  color: #48d1cc;
}

.status-badge-wrap {
  display: flex;
  align-items: center;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 12px;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.status-joined {
  background: rgba(34, 197, 94, 0.2);
  border: 1px solid rgba(34, 197, 94, 0.4);
  color: #4ade80;
}

.status-unlocked {
  background: rgba(72, 209, 204, 0.2);
  border: 1px solid rgba(72, 209, 204, 0.45);
  color: #48d1cc;
}

.status-locked {
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.35);
  color: #f87171;
}

/* Card Body */
.community-card-body {
  padding: 14px 18px 18px 18px;
  display: flex;
  flex-direction: column;
  flex: 1 1;
}

.card-header-identity {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: -30px;
  margin-bottom: 12px;
  position: relative;
  z-index: 3;
}

.community-avatar-img,
.community-avatar-placeholder {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  border: 2px solid #0f2321;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1e3d39 0%, #0d2220 100%);
  color: #48d1cc;
  font-size: 18px;
  font-weight: 700;
  object-fit: cover;
}

.city-av {
  color: #38bdf8;
  background: linear-gradient(135deg, #133347 0%, #0c202d 100%);
}

.pol-av {
  color: #a5b4fc;
  background: linear-gradient(135deg, #25244b 0%, #161530 100%);
}

.prof-av {
  color: #fbbf24;
  background: linear-gradient(135deg, #382c13 0%, #201908 100%);
}

.card-header-titles {
  flex: 1 1;
  min-width: 0;
  padding-top: 14px;
}

.card-title-text {
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 2px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
}

.card-member-text {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11.5px;
  color: #64748b;
  font-weight: 500;
}

.card-description-text {
  font-size: 13px;
  line-height: 1.45;
  color: #94a3b8;
  margin: 0 0 14px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  flex: 1 1;
}

/* Gating Requirement Capsule */
.card-requirement-box {
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  padding: 8px 12px;
  margin-bottom: 14px;
}

.req-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  font-weight: 500;
  color: #cbd5e1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.req-row span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Card Actions */
.card-action-wrapper {
  margin-top: auto;
}

.card-btn {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;
}

.btn-view-community {
  background: rgba(72, 209, 204, 0.12);
  border: 1px solid rgba(72, 209, 204, 0.3);
  color: #48d1cc;
}

.btn-view-community:hover {
  background: rgba(72, 209, 204, 0.22);
  border-color: #48d1cc;
  color: #ffffff;
  transform: translateY(-1px);
}

.btn-join-unlocked {
  background: linear-gradient(135deg, #48d1cc 0%, #20b2aa 100%);
  border: none;
  color: #061c1b;
  box-shadow: 0 4px 14px rgba(72, 209, 204, 0.25);
}

.btn-join-unlocked:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(72, 209, 204, 0.4);
}

.btn-gated-outline {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #94a3b8;
}

.btn-gated-outline:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.2);
  color: #f1f5f9;
}

.btn-gated-cert {
  background: rgba(72, 209, 204, 0.08);
  border: 1px dashed rgba(72, 209, 204, 0.35);
  color: #7ee6e1;
}

.btn-gated-cert:hover {
  background: rgba(72, 209, 204, 0.16);
  border-style: solid;
  color: #ffffff;
}

/* --------------------------------------------------------------------------
   5. LOADING & EMPTY STATES
   -------------------------------------------------------------------------- */
.community-loading-container,
.community-empty-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 60px 20px;
  background: rgba(13, 26, 25, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 20px;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.community-spinner {
  width: 38px;
  height: 38px;
  border: 3px solid rgba(72, 209, 204, 0.15);
  border-top-color: #48d1cc;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.community-loading-container p {
  color: #94a3b8;
  font-size: 14px;
  margin: 0;
}

.empty-icon-wrap {
  width: 68px;
  height: 68px;
  border-radius: 20px;
  background: rgba(72, 209, 204, 0.1);
  border: 1px solid rgba(72, 209, 204, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.community-empty-container h3 {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 8px 0;
}

.community-empty-container p {
  font-size: 13.5px;
  line-height: 1.5;
  color: #94a3b8;
  max-width: 480px;
  margin: 0 0 20px 0;
}

.btn-empty-action {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #48d1cc 0%, #20b2aa 100%);
  color: #061c1b;
  border: none;
  font-size: 13px;
  font-weight: 700;
  padding: 10px 22px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 16px rgba(72, 209, 204, 0.3);
}

.btn-empty-action:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(72, 209, 204, 0.45);
}

/* --------------------------------------------------------------------------
   6. RESPONSIVE MEDIA QUERIES
   -------------------------------------------------------------------------- */
@media (max-width: 900px) {
  .community-header-section {
    flex-direction: column;
    padding: 20px;
  }

  .community-header-stats {
    width: 100%;
    justify-content: flex-start;
  }

  .community-grid {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 16px;
  }

  .spotlight-cards-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 600px) {
  .CommunityListContainer {
    padding: 16px 12px 40px 12px;
  }

  .community-page-title {
    font-size: 22px;
  }

  .community-page-subtitle {
    font-size: 13px;
  }

  .community-search-bar-row {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .filter-summary-info {
    font-size: 12px;
    text-align: right;
  }

  .community-filter-bar {
    padding: 4px;
    gap: 8px;
  }

  .filter-tab-pill {
    padding: 6px 12px;
    font-size: 12.5px;
  }

  .community-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Communities/CommunityList/CommunityList.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,4BAA4B;EAC5B,cAAc;EACd,kEAAkE;EAClE,sBAAsB;AACxB;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,yFAAyF;EACzF,0CAA0C;EAC1C,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;EACnC,oFAAoF;AACtF;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,8DAA8D;EAC9D,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;+EAE+E;AAC/E;EACE,mBAAmB;EACnB,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,yFAAyF;EACzF,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,4EAA4E;AAC9E;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qFAAqF;EACrF,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,0BAA0B;EAC1B,kCAAkC;EAClC,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,iCAAiC;EACjC,6EAA6E;AAC/E;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,qCAAqC;EACrC,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,UAAU;EACV,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,OAAO;EACP,+EAA+E;AACjF;;AAEA;EACE,QAAQ;EACR,gFAAgF;AAClF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,mEAAmE;EACnE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qFAAqF;EACrF,kBAAkB;AACpB;;AAEA;EACE,qFAAqF;AACvF;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,oBAAoB;EACpB,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,0CAA0C;EAC1C,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wCAAwC;EACxC,0BAA0B;EAC1B,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,6BAA6B;EAC7B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,iDAAiD;EACjD,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,+FAA+F;EAC/F,yCAAyC;EACzC,cAAc;EACd,gBAAgB;EAChB,iFAAiF;AACnF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,wFAAwF;EACxF,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,4EAA4E;AAC9E;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,wFAAwF;AAC1F;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,6DAA6D;AAC/D;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,SAAO;AACT;;AAEA,+BAA+B;AAC/B;EACE,+BAA+B;EAC/B,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,iDAAiD;EACjD,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;+EAE+E;AAC/E;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;;+EAE+E;AAC/E;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ==========================================================================\n   COMMUNITY LIST - MODERN GLASSMORPHIC REDESIGN\n   ========================================================================== */\n\n.CommunityListContainer {\n  width: 100%;\n  max-width: 1240px;\n  margin: 0 auto;\n  padding: 28px 20px 60px 20px;\n  color: #f8fafc;\n  font-family: \"Instrument Sans\", \"Inter\", -apple-system, sans-serif;\n  box-sizing: border-box;\n}\n\n/* --------------------------------------------------------------------------\n   1. PAGE HEADER SECTION\n   -------------------------------------------------------------------------- */\n.community-header-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin-bottom: 28px;\n  padding: 24px 28px;\n  background: linear-gradient(135deg, rgba(16, 35, 33, 0.6) 0%, rgba(9, 20, 20, 0.85) 100%);\n  border: 1px solid rgba(72, 209, 204, 0.16);\n  border-radius: 20px;\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.08);\n}\n\n.community-header-left {\n  flex: 1;\n  min-width: 280px;\n}\n\n.community-header-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: rgba(72, 209, 204, 0.12);\n  border: 1px solid rgba(72, 209, 204, 0.3);\n  color: #48d1cc;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 11.5px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  margin-bottom: 10px;\n}\n\n.community-page-title {\n  font-size: 28px;\n  font-weight: 700;\n  letter-spacing: -0.5px;\n  margin: 0 0 6px 0;\n  color: #ffffff;\n  background: linear-gradient(105deg, #ffffff 40%, #7ee6e1 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.community-page-subtitle {\n  font-size: 14px;\n  line-height: 1.55;\n  color: #94a3b8;\n  max-width: 720px;\n  margin: 0;\n}\n\n.community-header-stats {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.stat-pill {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 18px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 14px;\n  min-width: 76px;\n}\n\n.stat-pill-joined {\n  background: rgba(72, 209, 204, 0.08);\n  border-color: rgba(72, 209, 204, 0.25);\n}\n\n.stat-num {\n  font-size: 20px;\n  font-weight: 700;\n  color: #ffffff;\n  line-height: 1;\n  margin-bottom: 2px;\n}\n\n.stat-pill-joined .stat-num {\n  color: #48d1cc;\n}\n\n.stat-label {\n  font-size: 11px;\n  font-weight: 500;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n/* --------------------------------------------------------------------------\n   2. UNLOCKED FOR YOU - SPOTLIGHT HUB\n   -------------------------------------------------------------------------- */\n.community-spotlight-hub {\n  margin-bottom: 28px;\n  background: rgba(13, 27, 26, 0.45);\n  border: 1px solid rgba(72, 209, 204, 0.18);\n  border-radius: 18px;\n  padding: 20px 22px;\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n}\n\n.spotlight-hub-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.spotlight-hub-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 15.5px;\n  font-weight: 700;\n  color: #f1f5f9;\n  letter-spacing: -0.2px;\n}\n\n.spotlight-hub-count {\n  font-size: 11px;\n  font-weight: 600;\n  background: rgba(72, 209, 204, 0.15);\n  border: 1px solid rgba(72, 209, 204, 0.35);\n  color: #48d1cc;\n  padding: 2px 8px;\n  border-radius: 10px;\n}\n\n.spotlight-hub-sub {\n  font-size: 12.5px;\n  color: #64748b;\n}\n\n.spotlight-cards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 14px;\n}\n\n.spotlight-card {\n  background: linear-gradient(145deg, rgba(20, 39, 37, 0.6) 0%, rgba(11, 23, 23, 0.8) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 14px;\n  padding: 16px 18px;\n  cursor: pointer;\n  transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n}\n\n.spotlight-card:hover {\n  transform: translateY(-2px);\n  border-color: rgba(72, 209, 204, 0.35);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4), 0 0 16px rgba(72, 209, 204, 0.12);\n}\n\n.spotlight-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: linear-gradient(90deg, transparent, rgba(72, 209, 204, 0.5), transparent);\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.spotlight-card:hover::before {\n  opacity: 1;\n}\n\n.spotlight-card-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.spotlight-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 3px 10px;\n  border-radius: 12px;\n  border: 1px solid;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n}\n\n.spotlight-members {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11.5px;\n  color: #94a3b8;\n}\n\n.spotlight-name {\n  font-size: 16px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 6px 0;\n  line-height: 1.3;\n}\n\n.spotlight-description {\n  font-size: 12.5px;\n  line-height: 1.45;\n  color: #94a3b8;\n  margin: 0 0 14px 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  flex: 1;\n}\n\n.spotlight-card-bottom {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  padding-top: 10px;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.spotlight-qual-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  color: #cbd5e1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.spotlight-join-btn {\n  background: linear-gradient(135deg, #48d1cc 0%, #20b2aa 100%);\n  color: #061c1b;\n  border: none;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 7px 16px;\n  border-radius: 20px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 10px rgba(72, 209, 204, 0.25);\n}\n\n.spotlight-join-btn:hover:not(:disabled) {\n  transform: scale(1.03);\n  box-shadow: 0 4px 14px rgba(72, 209, 204, 0.4);\n}\n\n.spotlight-join-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* --------------------------------------------------------------------------\n   3. CONTROL DECK (SEARCH + TABS)\n   -------------------------------------------------------------------------- */\n.community-control-deck {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.community-search-bar-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.community-search-wrapper {\n  position: relative;\n  flex: 1;\n  min-width: 260px;\n}\n\n.community-search-input {\n  width: 100%;\n  padding: 12px 38px 12px 16px;\n  background: rgba(15, 30, 28, 0.65);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  color: #ffffff;\n  font-size: 14px;\n  font-family: inherit;\n  outline: none;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  box-sizing: border-box;\n  transition: all 0.2s ease;\n}\n\n.community-search-input:focus {\n  border-color: #48d1cc;\n  background: rgba(15, 30, 28, 0.9);\n  box-shadow: 0 0 0 3px rgba(72, 209, 204, 0.15), 0 4px 16px rgba(0, 0, 0, 0.3);\n}\n\n.community-search-input::placeholder {\n  color: #64748b;\n  font-size: 13.5px;\n}\n\n.search-clear-btn {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(255, 255, 255, 0.08);\n  border: none;\n  color: #94a3b8;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.search-clear-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n}\n\n.filter-summary-info {\n  font-size: 13px;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n.filter-summary-info strong {\n  color: #e2e8f0;\n  font-weight: 600;\n}\n\n/* Modern Segmented Filter Bar with Visible Scrollbar & Overflow Hints */\n.community-filter-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 8px;\n  background: rgba(10, 22, 21, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 14px;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n.filter-tabs-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 1;\n  min-width: 260px;\n  overflow: hidden;\n}\n\n/* Gradient edge masks to indicate hidden scrollable content */\n.filter-tabs-wrapper::before,\n.filter-tabs-wrapper::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 6px;\n  width: 32px;\n  pointer-events: none;\n  z-index: 2;\n  opacity: 0;\n  transition: opacity 0.25s ease;\n}\n\n.filter-tabs-wrapper::before {\n  left: 0;\n  background: linear-gradient(90deg, rgba(10, 22, 21, 0.95) 0%, transparent 100%);\n}\n\n.filter-tabs-wrapper::after {\n  right: 0;\n  background: linear-gradient(270deg, rgba(10, 22, 21, 0.95) 0%, transparent 100%);\n}\n\n.filter-tabs-wrapper.has-scroll-left::before {\n  opacity: 1;\n}\n\n.filter-tabs-wrapper.has-scroll-right::after {\n  opacity: 1;\n}\n\n/* Slim custom glowing scrollbar */\n.filter-tabs-track {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  width: 100%;\n  padding-bottom: 6px;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(72, 209, 204, 0.45) rgba(255, 255, 255, 0.04);\n  scroll-behavior: smooth;\n}\n\n.filter-tabs-track::-webkit-scrollbar {\n  height: 4px;\n}\n\n.filter-tabs-track::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.04);\n  border-radius: 4px;\n  margin: 0 4px;\n}\n\n.filter-tabs-track::-webkit-scrollbar-thumb {\n  background: linear-gradient(90deg, rgba(72, 209, 204, 0.5), rgba(32, 178, 170, 0.65));\n  border-radius: 4px;\n}\n\n.filter-tabs-track::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(90deg, rgba(72, 209, 204, 0.8), rgba(32, 178, 170, 0.95));\n}\n\n/* Scroll Arrow Navigation Buttons */\n.tabs-scroll-btn {\n  position: absolute;\n  top: calc(50% - 3px);\n  transform: translateY(-50%);\n  z-index: 3;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: rgba(14, 30, 28, 0.9);\n  border: 1px solid rgba(72, 209, 204, 0.35);\n  color: #48d1cc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);\n  transition: all 0.18s ease;\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n}\n\n.tabs-scroll-btn:hover {\n  background: rgba(72, 209, 204, 0.25);\n  border-color: #48d1cc;\n  color: #ffffff;\n  transform: translateY(-50%) scale(1.08);\n}\n\n.scroll-btn-left {\n  left: 2px;\n}\n\n.scroll-btn-right {\n  right: 2px;\n}\n\n.filter-tab-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: transparent;\n  border: 1px solid transparent;\n  color: #94a3b8;\n  font-size: 13.5px;\n  font-weight: 500;\n  font-family: inherit;\n  padding: 7px 16px;\n  border-radius: 10px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  user-select: none;\n}\n\n.filter-tab-pill:hover {\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.filter-tab-pill.active {\n  background: linear-gradient(135deg, rgba(72, 209, 204, 0.18) 0%, rgba(32, 178, 170, 0.24) 100%);\n  border: 1px solid rgba(72, 209, 204, 0.4);\n  color: #48d1cc;\n  font-weight: 600;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25), inset 0 1px 0 rgba(72, 209, 204, 0.2);\n}\n\n.filter-tab-text {\n  letter-spacing: -0.1px;\n}\n\n.filter-tab-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.07);\n  color: #94a3b8;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 1px 7px;\n  border-radius: 9999px;\n  min-width: 14px;\n  transition: all 0.2s ease;\n}\n\n.filter-tab-pill:hover .filter-tab-count {\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.filter-tab-pill.active .filter-tab-count {\n  background: rgba(72, 209, 204, 0.25);\n  color: #ffffff;\n}\n\n/* --------------------------------------------------------------------------\n   4. COMMUNITY CARDS GRID\n   -------------------------------------------------------------------------- */\n.community-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));\n  gap: 20px;\n}\n\n.community-card {\n  background: linear-gradient(160deg, rgba(17, 33, 31, 0.7) 0%, rgba(8, 18, 18, 0.9) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 18px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);\n}\n\n.community-card:hover {\n  transform: translateY(-4px);\n  border-color: rgba(72, 209, 204, 0.35);\n  box-shadow: 0 14px 32px rgba(0, 0, 0, 0.5), 0 0 20px rgba(72, 209, 204, 0.1);\n}\n\n/* Card Banner */\n.community-card-banner {\n  height: 90px;\n  background-size: cover;\n  background-position: center;\n  background-color: #0c1a19;\n  position: relative;\n  padding: 12px 14px;\n  box-sizing: border-box;\n}\n\n.community-card-banner-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, rgba(6, 15, 14, 0.3) 0%, rgba(6, 15, 14, 0.85) 100%);\n}\n\n.card-top-row {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.category-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 3px 10px;\n  border-radius: 12px;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n}\n\n.city-tag {\n  background: rgba(56, 189, 248, 0.15);\n  border: 1px solid rgba(56, 189, 248, 0.35);\n  color: #38bdf8;\n}\n\n.political-tag {\n  background: rgba(129, 140, 248, 0.15);\n  border: 1px solid rgba(129, 140, 248, 0.35);\n  color: #a5b4fc;\n}\n\n.profession-tag {\n  background: rgba(245, 158, 11, 0.15);\n  border: 1px solid rgba(245, 158, 11, 0.35);\n  color: #fbbf24;\n}\n\n.merit-tag {\n  background: rgba(72, 209, 204, 0.15);\n  border: 1px solid rgba(72, 209, 204, 0.35);\n  color: #48d1cc;\n}\n\n.status-badge-wrap {\n  display: flex;\n  align-items: center;\n}\n\n.status-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 3px 10px;\n  border-radius: 12px;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n}\n\n.status-joined {\n  background: rgba(34, 197, 94, 0.2);\n  border: 1px solid rgba(34, 197, 94, 0.4);\n  color: #4ade80;\n}\n\n.status-unlocked {\n  background: rgba(72, 209, 204, 0.2);\n  border: 1px solid rgba(72, 209, 204, 0.45);\n  color: #48d1cc;\n}\n\n.status-locked {\n  background: rgba(239, 68, 68, 0.15);\n  border: 1px solid rgba(239, 68, 68, 0.35);\n  color: #f87171;\n}\n\n/* Card Body */\n.community-card-body {\n  padding: 14px 18px 18px 18px;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.card-header-identity {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: -30px;\n  margin-bottom: 12px;\n  position: relative;\n  z-index: 3;\n}\n\n.community-avatar-img,\n.community-avatar-placeholder {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  border: 2px solid #0f2321;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #1e3d39 0%, #0d2220 100%);\n  color: #48d1cc;\n  font-size: 18px;\n  font-weight: 700;\n  object-fit: cover;\n}\n\n.city-av {\n  color: #38bdf8;\n  background: linear-gradient(135deg, #133347 0%, #0c202d 100%);\n}\n\n.pol-av {\n  color: #a5b4fc;\n  background: linear-gradient(135deg, #25244b 0%, #161530 100%);\n}\n\n.prof-av {\n  color: #fbbf24;\n  background: linear-gradient(135deg, #382c13 0%, #201908 100%);\n}\n\n.card-header-titles {\n  flex: 1;\n  min-width: 0;\n  padding-top: 14px;\n}\n\n.card-title-text {\n  font-size: 16px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 2px 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.3;\n}\n\n.card-member-text {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11.5px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.card-description-text {\n  font-size: 13px;\n  line-height: 1.45;\n  color: #94a3b8;\n  margin: 0 0 14px 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  flex: 1;\n}\n\n/* Gating Requirement Capsule */\n.card-requirement-box {\n  background: rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 10px;\n  padding: 8px 12px;\n  margin-bottom: 14px;\n}\n\n.req-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11.5px;\n  font-weight: 500;\n  color: #cbd5e1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.req-row span {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Card Actions */\n.card-action-wrapper {\n  margin-top: auto;\n}\n\n.card-btn {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border-radius: 12px;\n  font-size: 13px;\n  font-weight: 700;\n  font-family: inherit;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  box-sizing: border-box;\n}\n\n.btn-view-community {\n  background: rgba(72, 209, 204, 0.12);\n  border: 1px solid rgba(72, 209, 204, 0.3);\n  color: #48d1cc;\n}\n\n.btn-view-community:hover {\n  background: rgba(72, 209, 204, 0.22);\n  border-color: #48d1cc;\n  color: #ffffff;\n  transform: translateY(-1px);\n}\n\n.btn-join-unlocked {\n  background: linear-gradient(135deg, #48d1cc 0%, #20b2aa 100%);\n  border: none;\n  color: #061c1b;\n  box-shadow: 0 4px 14px rgba(72, 209, 204, 0.25);\n}\n\n.btn-join-unlocked:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 18px rgba(72, 209, 204, 0.4);\n}\n\n.btn-gated-outline {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #94a3b8;\n}\n\n.btn-gated-outline:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.2);\n  color: #f1f5f9;\n}\n\n.btn-gated-cert {\n  background: rgba(72, 209, 204, 0.08);\n  border: 1px dashed rgba(72, 209, 204, 0.35);\n  color: #7ee6e1;\n}\n\n.btn-gated-cert:hover {\n  background: rgba(72, 209, 204, 0.16);\n  border-style: solid;\n  color: #ffffff;\n}\n\n/* --------------------------------------------------------------------------\n   5. LOADING & EMPTY STATES\n   -------------------------------------------------------------------------- */\n.community-loading-container,\n.community-empty-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 60px 20px;\n  background: rgba(13, 26, 25, 0.4);\n  border: 1px solid rgba(255, 255, 255, 0.07);\n  border-radius: 20px;\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n}\n\n.community-spinner {\n  width: 38px;\n  height: 38px;\n  border: 3px solid rgba(72, 209, 204, 0.15);\n  border-top-color: #48d1cc;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  margin-bottom: 16px;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.community-loading-container p {\n  color: #94a3b8;\n  font-size: 14px;\n  margin: 0;\n}\n\n.empty-icon-wrap {\n  width: 68px;\n  height: 68px;\n  border-radius: 20px;\n  background: rgba(72, 209, 204, 0.1);\n  border: 1px solid rgba(72, 209, 204, 0.25);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.community-empty-container h3 {\n  font-size: 18px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 8px 0;\n}\n\n.community-empty-container p {\n  font-size: 13.5px;\n  line-height: 1.5;\n  color: #94a3b8;\n  max-width: 480px;\n  margin: 0 0 20px 0;\n}\n\n.btn-empty-action {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: linear-gradient(135deg, #48d1cc 0%, #20b2aa 100%);\n  color: #061c1b;\n  border: none;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 10px 22px;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 16px rgba(72, 209, 204, 0.3);\n}\n\n.btn-empty-action:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(72, 209, 204, 0.45);\n}\n\n/* --------------------------------------------------------------------------\n   6. RESPONSIVE MEDIA QUERIES\n   -------------------------------------------------------------------------- */\n@media (max-width: 900px) {\n  .community-header-section {\n    flex-direction: column;\n    padding: 20px;\n  }\n\n  .community-header-stats {\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .community-grid {\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n    gap: 16px;\n  }\n\n  .spotlight-cards-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 600px) {\n  .CommunityListContainer {\n    padding: 16px 12px 40px 12px;\n  }\n\n  .community-page-title {\n    font-size: 22px;\n  }\n\n  .community-page-subtitle {\n    font-size: 13px;\n  }\n\n  .community-search-bar-row {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n  }\n\n  .filter-summary-info {\n    font-size: 12px;\n    text-align: right;\n  }\n\n  .community-filter-bar {\n    padding: 4px;\n    gap: 8px;\n  }\n\n  .filter-tab-pill {\n    padding: 6px 12px;\n    font-size: 12.5px;\n  }\n\n  .community-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
